module.exports = __webpack_public_path__ + "static/media/YB5M12_2.ac4c6b95.jpg";